// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});$w.onReady(function(){

$w('#seasononebutton').onClick(() => {
	$w('#seasonone').expand();
	$w('#seasononebox').show();
	
	$w('#seasontwo').collapse();
	$w('#seasontwobox').hide();

	$w('#seasonthree').collapse();
	$w('#seasonthreebox').hide();
	
})

$w('#seasontwobutton').onClick(() => {
	$w('#seasonone').collapse();
	$w('#seasononebox').hide();
	
	$w('#seasontwo').expand();
	$w('#seasontwobox').show();

	$w('#seasonthree').collapse();
	$w('#seasonthreebox').hide();
	
})

$w('#seasonthreebutton').onClick(() => {
	$w('#seasonone').collapse();
	$w('#seasononebox').hide();
	
	$w('#seasontwo').collapse();
	$w('#seasontwobox').hide();

	$w('#seasonthree').expand();
	$w('#seasonthreebox').show();
	
})

});